import styled from 'styled-components';
import { css } from '/imports/ui/css';

export const AppStyled = styled.div`
  height: 100%;
  width: 100%;
  overflow: auto;
  display: flex;
  color: ${css.black};
  background: ${css.backgroundColor};
  a {
    color: ${css.primaryColor};
    transition: color 0.2s ease;
    &:hover {
      color: ${css.primaryColor2};
    }
  }
  h1, h2, h3, h4, h5 {
    font-weight: normal;
  }
  .cursor-pointer {
    cursor: pointer;
  }
`;